<template>
  <div class="hero is-fullheight" id="app">
    <div id="mainContainer">
      <sidebar id="desktop" v-if="isLoggedIn" />
      <navbar-mobile id="mobile" v-if="isLoggedIn" />

      <router-view id="page" />
    </div>
  </div>
</template>

<script>
import Webservices from "@/Webservices";
import store from "@/store";
import { mapActions, mapGetters, mapState } from "vuex";
import TimeMe from "timeme.js";

import FloatingTab from "@/components/FloatingTab";

import { getPageName } from "@/functions/pathsName.js";
import navTab from "./components/custom/navbar.vue";

import sidebar from "./components/custom/sidebar/sidebar.vue";
import navbarMobile from "./components/custom/navbarMobile/navbarMobile.vue";

const ws = new Webservices();
const Json2csvParser = require("json2csv").Parser;
var FileSaver = require("file-saver");
var moment = require("moment");

export default {
  name: "App",
  components: {
    FloatingTab,
    navTab,
    sidebar,
    navbarMobile
  },
  data() {
    return {
      exib_client_list: true,
      drawerRadios: { open: false },
      photo: "",
      start_date: "",
      end_date: "",
      dateSD: "",
      dateED: "",
      modalSD: false,
      modalED: false,
      dialog: false,
      dialogImport: false,
      drawer: true,
      selectedGroup: null,
      selectedGroupList: [],
      clientList: [],
      selectedClient: null,
      currentSelectedClient: undefined,
      lastSelectedClient: undefined,
      exibe_bar: true,
      activeItem: "dashboard",
      openModalAdm: false,
      openSideBarMobile: false
    };
  },
  created() {
    ws.setToken(this.getToken);
    ws.updateAccessToken(this.getToken);
    this.loadClient();

    window.addEventListener("beforeunload", this.unloadWindowActions);

    this.initTimers();
  },
  computed: {
    ...mapState({ client: state => state.client, group: state => state.group }),
    ...mapGetters([
      "isLoggedIn",
      "getCurrentPage",
      "getCurrentModal",
      "getName",
      "isADM",
      "getPhoto",
      "isDark",
      "getClient",
      "getClientName",
      "getClientLogo",
      "isROOT",
      "getRules",
      "getClients",
      "getClientID",
      "getClientsByGroupId",
      "getClientsByGroupIdShort",
      "getGroupsByFatherId",
      "getToken"
    ]),
    photoData() {
      return this.getPhoto;
    },
    haveClient() {
      if (store.state.client) {
        return store.state.client.id != null;
      } else {
        return false;
      }
    },
    haveClientNotGroup() {
      return (
        store.state.client &&
        store.state.client.id != null &&
        store.state.client.id != "all"
      );
    },
    clientHasMap() {
      return store.state.client && store.state.client.coordinates != null;
    },
    clientHasNotifications() {
      return store.state.client && store.state.client.mapActive != null;
    }
  },
  watch: {
    isROOT() {
      if (this.isROOT) {
        this.getSchoolGroup().then(() => {
          this.choiceGroup(this.selectedGroupList[0].id).then(() => {
            if (this.clientList[0].id == "all") {
              this.choiceClient(this.clientList[1].id);
            } else {
              this.choiceClient(this.clientList[0].id);
            }
          });
        });
      }
    },

    getCurrentPage(page) {
      TimeMe.stopAllTimers();
      TimeMe.startTimer(page);
    },

    getCurrentModal(modal) {
      TimeMe.stopAllTimers();
      if (modal === undefined) {
        const path = this.$router.currentRoute.path;
        const page = getPageName(path);

        TimeMe.startTimer(page);
      } else {
        TimeMe.startTimer(modal);
      }
    }
  },
  mounted() {
    if (this.isROOT) {
      this.getSchoolGroup().then(() => {
        this.choiceGroup(this.selectedGroupList[0].id).then(() => {
          if (this.clientList[0].id == "all") {
            if (store.state.client && store.state.client.id) {
              this.choiceClient(store.state.client.id);
            } else {
              this.choiceClient(this.clientList[1].id);
            }
          } else {
            if (store.state.client && store.state.client.id) {
              this.choiceClient(store.state.client.id);
            } else {
              this.choiceClient(this.clientList[0].id);
            }
          }
        });
      });
    }
  },

  methods: {
    ...mapActions(["logout", "selectClient"]),

    //Estudar alguma forma de mandar esses dados periodicamente
    //Atualmente os dados são enviados em LOGOUT/FECHAR ABA/MUDAR PARA OUTRA PAGINA/TROCA DE CLIENTE

    //Reinicializa os cronometros
    initTimers() {
      const path = this.$router.currentRoute.path;

      TimeMe.resetAllRecordedPageTimes();
      TimeMe.initialize({
        idleTimeoutInSeconds: 600,
        currentPageName: getPageName(path)
      });
    },
    unloadWindowActions() {
      //TROCAR O NOME DO LOCAL STORAGE PARA ALGO MENOS GENERICO
      const { client } = JSON.parse(localStorage.getItem("data"));
      let clientId = client != undefined ? client.controller_id : undefined;
    },
    choiceClient(clientId) {
      if (clientId == "all") {
        var client = {
          id: "all",
          name: "todos",
          controller_id: "all"
        };
      } else {
        //console.log("cliente selecionado: ",clientId )
        var client = this.getClients.find(el => el.id == clientId);
        //console.log("cliente selecionado: ",client )
      }
      //this.selectedClient = "5ed817c8b3a856200a282f3a"
      this.exibe_bar = false;
      //this.exib_client_list = false
      setTimeout(() => {
        this.exibe_bar = true;
        //this.exib_client_list = true;
      }, 250);
      store.state.group_client_await = false;
      this.selectClient(client);

      //Atualiza a informacao do ultimo cliente selecionado
      this.lastSelectedClient = this.currentSelectedClient;

      const { client: client_info } = JSON.parse(localStorage.getItem("data"));
      this.currentSelectedClient =
        client_info != undefined ? client_info.controller_id : undefined;
      this.openModalAdm = false;
    },
    closeDialog() {
      this.dialogImport = false;
      this.dateSD = "";
      this.dateED = "";
      this.start_date = "";
      this.end_date = "";
    },
    loadClient() {
      ws.getClientsByGroupId(store.state.groupId).then(res => {
        //console.log("res.data[0].id: ",res.data[0].id )
      });
    },
    getSchoolGroup() {
      return new Promise((resolve, reject) => {
        var groups = [];
        ws.getGroups().then(res => {
          var groups_ = res.data;
          var fathers = [];
          groups_.forEach(group => {
            if (fathers.indexOf(group.father_id) === -1) {
              fathers.push(group.father_id);
            }
          });

          groups_.forEach(group => {
            if (fathers.indexOf(group.id) === -1 || group.id != 99) {
              groups.push(group);
            }
          });

          this.selectedGroupList = groups;
          resolve(1);
        });
      });
    },
    choiceGroup(groupId) {
      //console.log("1.this.exib_client_list = ",this.exib_client_list)
      this.exib_client_list = false;
      //console.log("2.this.exib_client_list = ",this.exib_client_list)

      // if(store.state.client){
      //   //console.log("store.state.client.id = ",store.state.client.id)
      //   //console.log("store.state.client.ex_id = ",store.state.client.ex_id)
      //   if(store.state.client.id == "123"){
      //     store.state.client.id = store.state.client.ex_id
      //   } else {
      //     store.state.client.ex_id = store.state.client.id
      //     store.state.client.id = "123";
      //     //console.log("store.state.client.ex_id = ",this.exib_client_list)
      //   }
      // }

      return new Promise((resolve, reject) => {
        ws.getGroups().then(res => {
          this.selectedGroup = res.data.find(el => el.id == groupId);
          this.getClientsFromGroup().then(() => {
            resolve(1);
          });
        });
      });
    },
    getGroupList() {
      return this.selectedGroupList;
    },
    getClientsFromGroup() {
      store.state.group_client_await = true;
      return new Promise((resolve, reject) => {
        ws.getClientsByGroupIdShort(this.selectedGroup.id).then(resp => {
          this.exib_client_list = false;
          if (resp.data.length > 1) {
            this.exibe_bar = false;
            this.selectClient(resp.data[0]);
            setTimeout(() => {
              this.exibe_bar = true;
            }, 250);
            this.selectedClient = resp.data[0].id;
            store.state.group_client_await = false;
            this.clientList = [];
            for (let cliente of resp.data) {
              this.clientList.push({
                name: cliente.name,
                id: cliente.id
              });
            }
            this.clientList.unshift({
              name: "Todos",
              id: "all",
              radio_prefix: "all"
            });
          } else {
            this.clientList = resp.data;
            if (resp.data.length) {
              this.selectClient(resp.data[0]);
              this.selectedClient = resp.data[0].id;
              store.state.group_client_await = false;
            }
            //this.exib_client_list = true;
          }
          store.state.group_selected_clients = resp.data;
          store.state.group_selected = this.selectedGroup;
          setTimeout(() => {
            this.exib_client_list = true;
          }, 1000);
          resolve(1);
        });
      });
    },
    exit() {
      this.logout();
      this.$router.push("/login");
    },
    items(isAdm, isRoot) {
      var saida = [];
      var self = this;

      if (isAdm && isRoot) {
        saida = [
          {
            id: "1",
            title: "Clientes",
            icon: "business",
            path: "clientes",
            disabled: false
          },
          {
            id: "2",
            title: "Usuários",
            icon: "supervisor_account",
            path: "usuarios",
            disabled: false
          },
          {
            id: "3",
            title: "Configurações",
            icon: "settings",
            path: "admSettings",
            disabled: false
          },
          {
            id: "4",
            title: "Overview",
            icon: "remove_red_eye",
            path: "/overview",
            disabled: false
          },
          {
            id: "4_1",
            title: "divider"
          },
          {
            id: "5",
            title: "Dashboard",
            icon: "dashboard",
            path: "dashboard_adm",
            disabled: !this.haveClient
          },
          {
            id: "6",
            title: "Voucher",
            icon: "vpn_lock",
            path: "/admVoucher",
            disabled: !this.haveClient
          },
          {
            id: "7",
            title: "Perguntas",
            icon: "assignment",
            path: "/admPerguntas",
            admArea: true,
            disabled: false
          },
          {
            id: "8",
            title: "Mídias",
            icon: "local_movies",
            path: "/admVideos",
            admArea: true,
            disabled: false
          },
          {
            id: "9",
            title: "Acessos Wi-Fi",
            icon: "mobile_friendly",
            path: "/admPessoas",
            admArea: true,
            disabled: !this.haveClient
          },
          {
            id: "10",
            title: "Vagalumes",
            icon: "vpn_lock",
            path: "/radios",
            disabled: !this.haveClient
          },
          {
            id: "11",
            title: "Email",
            icon: "Email",
            path: "/emails",
            disabled: !this.haveClient
          },
          {
            id: "12",
            title: "Birthday",
            icon: "birthday",
            path: "/birthday",
            disabled: !this.haveClient
          },
          {
            id: "13",
            title: "Recurrence",
            icon: "vpn_lock",
            path: "/recurrence",
            disabled: !this.haveClient
          }
        ];
      } else if (isAdm && !isRoot) {
        saida = [
          {
            id: "1",
            title: "Overview",
            icon: "remove_red_eye",
            path: "/overview",
            disabled: false
          },
          {
            id: "1_1",
            title: "Usuários",
            icon: "supervisor_account",
            path: "/usuarios",
            disabled: false
          },
          {
            id: "2",
            title: "Configurações",
            icon: "settings",
            path: "admSettings",
            disabled: false
          },
          {
            id: "2_1",
            title: "divider"
          },
          {
            id: "3",
            title: "Dashboard",
            icon: "dashboard",
            path: "dashboard_adm",
            disabled: !this.haveClient
          },
          {
            id: "4",
            title: "Voucher",
            icon: "vpn_lock",
            path: "/admVoucher",
            disabled: !this.haveClient
          },

          {
            id: "5",
            title: "Perguntas",
            icon: "assignment",
            path: "/admPerguntas",
            admArea: true,
            disabled: false
          },
          {
            id: "6",
            title: "Mídias",
            icon: "local_movies",
            path: "/admVideos",
            admArea: true,
            disabled: false
          },
          {
            id: "7",
            title: "Acessos Wi-Fi",
            icon: "mobile_friendly",
            path: "/admPessoas",
            admArea: true,
            disabled: !this.haveClient
          },
          {
            id: "8",
            title: "Vagalumes",
            icon: "vpn_lock",
            path: "/radios",
            disabled: !this.haveClient
          },
          {
            id: "9",
            title: "Email",
            icon: "vpn_lock",
            path: "/emails",
            disabled: !this.haveClient
          },
          {
            id: "10",
            title: "Birthday",
            icon: "vpn_lock",
            path: "/birthday",
            disabled: !this.haveClient
          },
          {
            id: "11",
            title: "Recurrence",
            icon: "vpn_lock",
            path: "/recurrence",
            disabled: !this.haveClient
          }
        ];
      } else {
        saida = [
          {
            id: "1",
            title: "Dashboard",
            icon: "dashboard",
            path: "dashboard",
            admArea: false,
            disabled: !this.getRules.dashboard.list
          },
          {
            id: "2",
            title: "Mídias",
            icon: "local_movies",
            path: "videos",
            admArea: false,
            disabled: !this.getRules.videos.list
          },
          {
            id: "3",
            title: "Perguntas",
            icon: "assignment",
            path: "perguntas",
            admArea: false,
            disabled: !this.getRules.questions.list
          },
          {
            id: "4",
            title: "Acessos Wi-Fi",
            icon: "mobile_friendly",
            path: "pessoas",
            admArea: false,
            disabled: !this.getRules.acessos.list
          },
          {
            id: "5",
            title: "Configurações",
            icon: "settings",
            path: "settings",
            disabled: false
          },
          {
            id: "6",
            title: "Voucher",
            icon: "vpn_lock",
            path: "/voucher",
            disabled: !this.getRules.vouchers.list
          },
          {
            id: "7",
            title: "Vagalumes",
            icon: "vpn_lock",
            path: "/radios",
            disabled: !this.haveClient
          },
          {
            id: "8",
            title: "Email",
            icon: "vpn_lock",
            path: "/emails",
            disabled: false
          },
          {
            id: "9",
            title: "Birthday ",
            icon: "vpn_lock",
            path: "/birthday",
            disabled: false
          },
          {
            id: "10",
            title: "Recurrence",
            icon: "vpn_lock",
            path: "/recurrence",
            disabled: !this.haveClient
          }
        ];
      }

      return saida;
    },
    action(item) {
      if (item.hasOwnProperty("action")) item.action();
    }
  }
};
</script>

<style lang="scss">
// Import Bulma's core
@import "../node_modules/bulma/sass/utilities/_all";
@import url("https://fonts.googleapis.com/css?family=Ubuntu|K2D");

// Set your colors
$menu-item-color: #f56618;
$light: #94999b;
$primary: #f56618;
$base: #eee;
$secondary: #424242;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);

* {
  font-family: "Ubuntu", Arial, Helvetica, sans-serif;
}

#app {
  color: #2c3e50;
  text-align: center;
  background-color: $base;
}

@media screen and (min-width: 1025px) {
  #mobile {
    display: none;
  }
  #mainContainer {
    display: flex;
    justify-content: space-around;
  }
  #page {
    width: 100%;
  }
}
@media screen and (max-width: 1024px) {
  #desktop {
    display: none;

    position: absolute;
  }
}

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>



// WEBPACK FOOTER //
// src/App.vue